export default __webpack_public_path__ + "img/66471521ff29093ec18f5d08b9c9c79d.svg";